
/**
 * Accordion tabs
 */


// Initialize the module.
  (function(){
    function loadAccordion() {
      accordionTabs();
      // accordionTabs.init();
    }
  function defer() {
    if (window.jQuery) {
      loadAccordion();
    } else {
      setTimeout(function() { defer() }, 50);
    }
  }
  defer();
  })();

  function accordionTabs() {
    var $accordionTabs = $('.accordion-tabs');

    if ( $accordionTabs.length ) {
        $accordionTabs.each(function(index) {
            $(this).children('li').first().children('.tab-header').addClass('is-active').next('.tab-content').addClass('is-open').show();
        });

        $accordionTabs.on('click', 'li a.tab-link', function(event) {
            event.preventDefault();

            if (!$(this).closest('.tab-header').hasClass('is-active')) {
                var accordionTabs = $(this).closest('.accordion-tabs');
                accordionTabs.find('.is-open').removeClass('is-open').hide();

                $(this).closest('.tab-header').next().toggleClass('is-open').toggle();
                accordionTabs.find('.is-active').removeClass('is-active');
                $(this).closest('.tab-header').addClass('is-active');
            }
        });
    }
  }
  /*
var accordionTabs = ( function ($) {
    'use strict';
    var module = {};

    module.init = function () {
        $(document).ready(()=> {


        });

    };

    return module;
}(jQuery)); */

